export default "__VITE_ASSET__BQXrBAkA__"